import {
  ADD_TRANSLATION_TABLE,
  ADD_TT_COL_LIST_ITEM,
  ADD_TT_COLUMN,
  ADD_TT_ROW,
  CANCEL_MATCH_COL_LIST,
  CHANGING_COL_LIST,
  CHANGING_COL_LIST_SUCCESS,
  CLEAR_ROWS,
  DELETE_TRANSLATION_TABLE_SUCCESS,
  DELETE_TT_COL_LIST_ITEM,
  FETCH_TT_COL_LIST_ITEMS,
  FETCH_TT_DATA,
  RESET_TRANSLATION_TABLE,
  SAVE_MATCH_COL_LIST_SUCCESS,
  SAVE_TRANSLATION_TABLE,
  SAVING_TRANSLATION_TABLE,
  UPDATE_TRANSLATION_TABLE,
  UPDATE_TT_COL_LIST_ITEM,
  SET_TT_EDITION_MODE,
  RESET_TT_EDITION_MODE,
  FETCH_TRANSLATION_TABLE_SUCCESS,
  FETCHING_TRANSLATION_TABLE,
  FETCHING_TT_DATA,
  CLEAR_LIST_ITEMS,
  UPDATE_SOURCE_COLUMN,
  UPDATE_TARGET_COLUMN,
  FETCHING_ALL_TRANSLATION_TABLES,
  FETCH_ALL_TRANSLATION_TABLES_SUCCESS
} from "./TranslationTableConstants";

const initialState = {
  sourceColumns: [],
  targetColumn: null,
  translationTable: {
    id: null,
    name: '',
    description: ''
  },
  rows: [],
  lists: [],
  isSaving: false,
  changingColList: false,
  deletingRow: false,
  translationTableFromCreate: false,
  translationTableEditionMode: false,
  fetchingAllTranslationTables: false,
  fetchingTranslationTable: false,
  fetchingTranslationTableData: false
};

const TranslationTableReducer = (state = initialState, action) =>  {
  switch (action.type) {
    case RESET_TRANSLATION_TABLE:
      return { ...initialState };
    case FETCHING_ALL_TRANSLATION_TABLES:
      return { ...initialState, fetchingAllTranslationTables: true };
    case FETCH_ALL_TRANSLATION_TABLES_SUCCESS: 
      return { ...initialState, fetchingAllTranslationTables: false};
    case ADD_TRANSLATION_TABLE: // eslint-disable-line no-case-declarations
      const { translationTable, targetColumn, sourceColumn, sourceInput, targetInput } = action;
      return {
        ...state,
        translationTableFromCreate: true,
        translationTable: { ...initialState.translationTable, id: translationTable.id },
        targetColumn,
        sourceColumns: [ sourceColumn ],
        rows: [
          {
            sourceInputs: [ sourceInput ],
            targetInput
          }
        ]
      };
    case ADD_TT_COLUMN:
      return {
        ...state,
        sourceColumns: [ ...state.sourceColumns, action.sourceColumn ],
        rows: state.rows.map(row => ({ ...row, sourceInputs: [ ...row.sourceInputs, { id: 12 } ] }))
      };
    case UPDATE_SOURCE_COLUMN:
      return {
        ...state,
        sourceColumns: state.sourceColumns.map((sourceColumn, index) => {
          if (index === action.index) {
            const updatedSourceColumn = { ...sourceColumn, sourceField: action.data };
            return updatedSourceColumn;
          }
        })
      };
    case UPDATE_TARGET_COLUMN:
      return {
        ...state,
        targetColumn: { ...state.targetColumn, sourceField: action.data }
      };
    case ADD_TT_ROW:
      return {
        ...state,
        rows: action.rows.map(({ translateDataDto, matchColumnDtoList }) => (
          {
            targetInput: { id: translateDataDto.id, translValue: translateDataDto.beingUpdated ? (translateDataDto.confirmedValue || '') : (translateDataDto.translValue || '') },
            sourceInputs: matchColumnDtoList.map(({ id, matchValue, confirmedValue, beingUpdated, listSize }) => ({ id, matchValue: beingUpdated ? confirmedValue || '' : matchValue || '', listSize }))
          }
        ))
      };
    case UPDATE_TRANSLATION_TABLE:
      return { ...state, translationTable: { ...state.translationTable, [action.field]: action.value } };
    case SAVE_TRANSLATION_TABLE:
      return {
        ...state,
        isSaving: false,
        translationTableFromCreate: false,
        translationTable: { ...initialState.translationTable },
        fetchingAllTranslationTables: false
      };
    case SAVING_TRANSLATION_TABLE:
      return { ...state, isSaving: true, fetchingAllTranslationTables: true };
    case ADD_TT_COL_LIST_ITEM: //eslint-disable-line no-case-declarations
      let listItem = state.lists.find(({ sourceInputId }) => (sourceInputId === action.sourceInputId));
      if (listItem) {
        listItem = { ...listItem, items: listItem.items.map(el => ({ ...el })) };
        listItem.items = [ { id: action.matchColListItem.id, matchValue: action.matchColListItem.confirmedValue || '' }, ...listItem.items ];
      }
      else {
        listItem = {
          sourceInputId: action.sourceInputId,
          items: [{ id: action.matchColListItem.id, matchValue: action.matchColListItem.confirmedValue || '' }]
        };
      }
      return {
        ...state,
        lists: [
          listItem,
          ...state.lists.filter(list => (list.sourceInputId !== action.sourceInputId))
        ]
      };
    case UPDATE_TT_COL_LIST_ITEM:
      lists = [ ...state.lists.map(list => ({ ...list, items: list.items.map(item => ({ ...item })) }))];
      return {...state, lists };
    case DELETE_TT_COL_LIST_ITEM:
      lists = [ ...state.lists.map(list => ({ ...list, items: list.items.map(item => ({ ...item })) }))];
      return { ...state, lists };
    case CLEAR_LIST_ITEMS:
      return { ...state, lists: [] };
    case CLEAR_ROWS:
      return { ...state, rows: [] };
    case FETCHING_TT_DATA:
      return { ...state, fetchingTranslationTableData: true };
    case FETCH_TT_COL_LIST_ITEMS: //eslint-disable-line no-case-declarations
      let lists;
      if (action.matchColListItems.length > 0) {
        lists = [
          {
            sourceInputId: action.sourceInputId,
            items: action.matchColListItems.map(({ id, matchValue, confirmedValue, beingUpdated }) => ({ id, matchValue: beingUpdated ? confirmedValue || '' : matchValue || '' }))
          },
          ...state.lists.filter(list => (list.sourceInputId !== action.sourceInputId)).map(list => ({ ...list }))
        ];
      }
      else {
        lists = state.lists.map(list => ({ ...list }));
      }
      return { ...state, lists, fetchingTranslationTableData: false };
    case CHANGING_COL_LIST:
      return { ...state, changingColList: true };
    case CHANGING_COL_LIST_SUCCESS:
      return { ...state, changingColList: false };
    case SAVE_MATCH_COL_LIST_SUCCESS: //eslint-disable-line no-case-declarations
      const rows = state.rows.map(row => (
        {
          targetInput: { ...row.targetInput },
          sourceInputs: row.sourceInputs.map(sourceInput => {
            const listFound = state.lists.find(list => (list.sourceInputId === sourceInput.id));
            return ({
              ...sourceInput,
              listSize: listFound ? listFound.items.length : 0
            });
          })
        }
      ));
      return {
        ...state,
        rows
      };
    case CANCEL_MATCH_COL_LIST:
      return { 
        ...state, 
        lists: state.lists.filter(list => (list.sourceInputId !== action.sourceInputId))
      };
    case FETCH_TT_DATA:
      return {
        ...state,
        fetchingTranslationTableData: false,
        rows: action.rows.map(({ translateDataDto, matchColumnDtoList }) => (
          {
            targetInput: { id: translateDataDto.id, translValue: translateDataDto.beingUpdated ? translateDataDto.confirmedValue || '' : translateDataDto.translValue || '' },
            sourceInputs: matchColumnDtoList.map(({ id, matchValue, confirmedValue, beingUpdated, listSize }) => ({ id, matchValue: beingUpdated ? confirmedValue || '' : matchValue || '', listSize }))
          }
        ))
      };
    case DELETE_TRANSLATION_TABLE_SUCCESS:
      return {
        ...state,
        translationTableFromCreate: false
      };
    case SET_TT_EDITION_MODE:
      return { ...state, translationTableEditionMode: true };
    case RESET_TT_EDITION_MODE:
      return { ...state, translationTableEditionMode: false };
    case FETCHING_TRANSLATION_TABLE:
      return { ...state, fetchingTranslationTable: true };
    case FETCH_TRANSLATION_TABLE_SUCCESS: //eslint-disable-line no-case-declarations
      const tTable = action.translationTable;
      const tTableTargetColumn = tTable.tableColumnDtoList.find(tableColumn => tableColumn.type === `TARGET`);
      return {
        ...state,
        fetchingTranslationTable: false,
        translationTable: { ...tTable.tableDto },
        rows: tTable.ttGrid.map(({ translateDataDto, matchColumnDtoList }) => (
          {
            targetInput: { id: translateDataDto.id, translValue: translateDataDto.beingUpdated ? translateDataDto.confirmedValue || '' : translateDataDto.translValue || '' },
            sourceInputs: matchColumnDtoList.map(({ id, matchValue, confirmedValue, beingUpdated, listSize }) => ({ id, matchValue: beingUpdated ? confirmedValue || '' : matchValue || '', listSize }))
          }
        )),
        sourceColumns: tTable.tableColumnDtoList.filter(tableColumn => tableColumn.type === `MATCH`).map( ({ id, beingUpdated, confirmedValue, sourceField }) => ({ id, sourceField: beingUpdated ? confirmedValue : sourceField || '' }) ),
        targetColumn: ({ id: tTableTargetColumn.id, sourceField: tTableTargetColumn.beingUpdated ? tTableTargetColumn.confirmedValue : tTableTargetColumn.sourceField })
      };
    default:
      return state;
  }
};

export default TranslationTableReducer;



// WEBPACK FOOTER //
// ./src/redux/translationTable/TranslationTableReducer.js